import type { IRouteConfig } from '@/types/common/router';
import { AdminNames } from './routerNames';

// const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//   navigator.userAgent
// );

// const componentString = isMobile
//   ? '../views/single/mobileActivity.vue'
//   : '../views/single/activity.vue';

/* @vite-ignore */
export const singleRouters: IRouteConfig[] = [
  {
    path: '/',
    name: AdminNames.SingleMain,
    component: () => import('@/components/Common/BaseSingle.vue'),
    redirect: { name: AdminNames.SingleHome },
    children: [
      // {
      //   path: 'activity',
      //   name: AdminNames.SingleActivity,
      //   meta: { title: '活动' },
      //   /* @vite-ignore */
      //   component: () => import('../views/single/activity.vue')
      // },
      // {
      //   path: 'mobile/activity',
      //   name: AdminNames.SingleActivityMobile,
      //   meta: { title: '活动' },
      //   /* @vite-ignore */
      //   component: () => import('../views/single/mobileActivity.vue')
      // },
      // {
      //   path: 'finaList',
      //   name: AdminNames.SingleActivityFinaList,
      //   meta: { title: '决赛名单' },
      //   component: () => import('@/views/single/finaList.vue')
      // },
      // {
      //   path: 'result',
      //   name: AdminNames.SingleResult,
      //   meta: { title: '决赛结果' },
      //   props: true,
      //   component: () => import('@/views/single/result.vue')
      // },
      // {
      //   path: 'enroll',
      //   name: AdminNames.SingleActivityEnroll,
      //   meta: { title: '活动报名' },
      //   component: () => import('@/views/single/mobileEnroll.vue')
      // },
      // {
      //   path: 'export',
      //   name: AdminNames.SingleExport,
      //   meta: { title: '导出记录' },
      //   component: () => import('@/views/admin/operation/exportList.vue')
      // },
      //
      // {
      //   path: 'institution',
      //   name: AdminNames.SingleInstitution,
      //   meta: { title: '机构' },
      //   component: () => import('@/views/single/institution.vue')
      // },
      // {
      //   path: 'screenshot',
      //   name: AdminNames.SingleScreenshot,
      //   meta: { title: '截图' },
      //   /* @vite-ignore */
      //   component: () => import('../views/single/screenshot.vue')
      // },
      {
        path: 'home',
        name: AdminNames.SingleHome,
        meta: { title: '全国高等医学院校大学生数字形态学读片和数字解剖标本辨识技能大赛' },
        component: () => import('../views/single/home.vue')
      },
      {
        path: 'wonderful/review',
        name: AdminNames.HomeWonderfulReview,
        meta: { title: '全国高等医学院校大学生数字形态学读片和数字解剖标本辨识技能大赛-精彩回顾' },
        component: () => import('../views/single/components/HomeWonderfulReview.vue')
      },
      // {
      //   path: 'wonderfulReview',
      //   name: AdminNames.SingleWonderfulReview,
      //   meta: { title: '精彩回顾' },
      //   component: () => import('../views/single/components/WonderfulReview.vue')
      // },

      // {
      //   path: 'slice/wonderful/review',
      //   name: AdminNames.HomeWonderfulReview,
      //   meta: { title: '首页' },
      //   component: () => import('../views/single/components/HomeWonderfulReview.vue')
      // },
      // {
      //   path: 'slice/wonderfulReview',
      //   name: AdminNames.SingleWonderfulReview,
      //   meta: { title: '精彩回顾' },
      //   component: () => import('../views/single/components/WonderfulReview.vue')
      // }
    ]
  }
];
